// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    crm_find_customers: 'Buscando en la cartera de clientes',
    crm_customer_profile: 'Leyendo la ficha del cliente',
    crm_summary: 'Sumando la cartera de clientes',
    crm_create_customer: 'Dando de alta un cliente',
    crm_update_customer: 'Cambiando la ficha del cliente',
  },
  ca: {
    crm_find_customers: 'Cercant a la cartera de clients',
    crm_customer_profile: 'Llegint la fitxa del client',
    crm_summary: 'Sumant la cartera de clients',
    crm_create_customer: 'Donant d’alta un client',
    crm_update_customer: 'Canviant la fitxa del client',
  },
  en: {
    crm_find_customers: 'Looking through the customer file',
    crm_customer_profile: 'Reading the customer\'s file',
    crm_summary: 'Adding up the customer base',
    crm_create_customer: 'Filing a new customer',
    crm_update_customer: 'Changing the customer file',
  },
  fr: {
    crm_find_customers: 'Recherche dans le fichier clients',
    crm_customer_profile: 'Lecture de la fiche du client',
    crm_summary: 'Bilan du fichier clients',
    crm_create_customer: 'Création d’un client',
    crm_update_customer: 'Modification de la fiche du client',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
